export default __webpack_public_path__ + "static/media/success-cellphone.34bbe732.svg";